<template>
  <div class="bg">
    <form class="form-signin">
      <div class="text-center mb-4">
        <img class="mb-4" src="/static/logo@2x.png" alt="" height="48">
        <h1 class="h3 mb-3 font-weight-normal">Merhaba, Ben Utku !</h1>
        <p></p>
      </div>

      <div class="form-label-group">
        <input type="text" id="inputEmail" class="form-control" v-model="username" placeholder="Email address" required autofocus>
        <label for="inputEmail">Kullanıcı Adınız</label>
      </div>

      <div class="form-label-group">
        <input type="password" id="inputPassword" class="form-control" v-model="password" placeholder="Password" required>
        <label for="inputPassword">Parolanız</label>
      </div>

      <div class="checkbox custom-control custom-checkbox mb-3">
        <input type="checkbox" class="custom-control-input" id="customCheck1">
        <label class="custom-control-label mt-1" for="customCheck1">Beni Hatırla</label>
      </div>
      <button class="btn btn-lg btn-primary btn-block" @click="handleSubmit" :disabled="loginning == true" v-bind:value="loginButtonText" type="submit">Oturum Aç</button>
      <p class="mt-5 mb-3 text-muted text-center">UTKU &copy; Lenoi 2026</p>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: '',
      peerip : '85.105.38.236',
      msg: 'Welcome to Your Vue.js App',
      loginning: false,
      loginStatus: false,
      loginMessage: null
    }
  },
  computed: {
    loginButtonText : function() { return this.loginning ? "Giriş Yapılıyor..." : "Giriş Yap" },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      if (this.password.length > 0 && this.username.length > 0) {
        this.loginning = true
        this.$store.dispatch('login', { 'UserName': this.username, 'Password': this.password, 'PeerIP': this.peerip })
        .then(() => {
          this.$store.dispatch('changeLoadingState', true)
          this.readUserConfig()     
        })
        .catch(error => {
          console.log(error)
          this.loginStatus = true
          this.loginMessage = 'Giriş yapılamadı.'
          this.loginning = false
          $(".alert").alert()
        })
      }
    },
    readUserConfig() {
      this.$store.dispatch('readUserConfig')
      .then(resp => {
        if(resp.data.HasError == false) {
        this.$store.dispatch('changeLoadingState', false)
          const redirect = this.$route.query.redirect
          this.$router.push(redirect && redirect.startsWith('/') ? redirect : '/')
        }
      })
      .catch(error => console.log(error))
    },
    checkSession() {
      console.log(this.getSessionId)
      if(this.getSessionId != undefined || this.getSessionId != null) {
        this.$store.dispatch('checkSession')
        .then(resp => {
          console.log(resp)
          if(resp.data.HasError == false) {
            const redirect = this.$route.query.redirect
            this.$router.push(redirect && redirect.startsWith('/') ? redirect : '/')
          }
        })
        .catch(error => console.log(error))
      }
    },
    checkNotificationPermission() {
      console.log('ilk log noktası')
      if('Notification' in window) {
        console.log('A- Noktası')
        this.requestNotificationPermission()
      } else
        console.log('B- Noktası')
    },
    requestNotificationPermission() {
      console.log("1- Permission is " + Notification.permission);
      if(Notification && Notification.permission === 'default') {
        Notification.requestPermission(function (permission) {
          if(!('permission' in Notification)) {
            Notification.permission = permission;
            console.log("2A- Bildirim hazırlanıyor...")
            this.showSampleNotification()
          }
        });
      } else if(Notification && Notification.permission === 'granted') {
        console.log("2B- Bildirim hazırlanıyor...")
        this.showSampleNotification()
      }
    },
    showSampleNotification() {
      this.desktopNotification()
    },
    desktopNotification() {
      if (Notification.permission === 'granted') {
        console.log("3- Bildirim gönderiliyor...")
        var text = "your Notification Body goes here";
        this.sendDesktopNotification(text);
      }
    },
    sendDesktopNotification(text) {
      let notification = new Notification('Your Page Title', {
        icon: '~/static/logo@2x.png',
        body: text,
        tag: 'soManyNotification'
      });
      console.log("4- Bildirim gönderildi.")
    }
  },
  mounted() {
    this.checkSession()
    //this.checkNotificationPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .bd-placeholder-img {
    font-size: 1.125rem;
    text-anchor: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  @media (min-width: 768px) {
    .bd-placeholder-img-lg {
      font-size: 3.5rem;
    }
  }

  html,
  body {
    height: 100%;
  }

  body {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #F5F5F5;
    z-index: 0;
  }

  .form-signin {
    width: 100%;
    max-width: 420px;
    padding: 40px 15px 15px 15px;
    margin: auto;
    z-index: 2;
  }

  .form-label-group {
    position: relative;
    margin-bottom: 1rem;
  }

  .form-label-group > input,
  .form-label-group > label {
    height: 3.125rem;
    padding: .75rem;
    padding-top: .85rem;
  }

  .form-label-group > label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    margin-bottom: 0; /* Override default `<label>` margin */
    line-height: 1.5;
    color: #9A9A9A;
    pointer-events: none;
    cursor: text; /* Match the input under the label */
    border: 1px solid transparent;
    border-radius: .25rem;
    transition: all .1s ease-in-out;
  }

  .form-label-group input::-webkit-input-placeholder {
    color: transparent;
  }

  .form-label-group input:-ms-input-placeholder {
    color: transparent;
  }

  .form-label-group input::-ms-input-placeholder {
    color: transparent;
  }

  .form-label-group input::-moz-placeholder {
    color: transparent;
  }

  .form-label-group input::placeholder {
    color: transparent;
  }

  .form-label-group input:not(:placeholder-shown) {
    padding-top: 1.25rem;
    padding-bottom: .25rem;
  }

  .form-label-group input:not(:placeholder-shown) ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #007bff;
  }

  /* Fallback for Edge
  -------------------------------------------------- */
  @supports (-ms-ime-align: auto) {
    .form-label-group > label {
      display: none;
    }
    .form-label-group input::-ms-input-placeholder {
      color: #777;
    }
  }

  /* Fallback for IE
  -------------------------------------------------- */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .form-label-group > label {
      display: none;
    }
    .form-label-group input:-ms-input-placeholder {
      color: #777;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login2Page.vue